import React from 'react';
import PropTypes from 'prop-types';
import ResourcesListItem from '../resources-list-item';
import TableListItem from '../table-list-item';
import ResourceType from '../../types/resource';

import './table-list.css';

const TableList = ({
  resources,
  selectedIndex,
  onSelect,
  onChangeLocation,
  ...otherProps
}) => (
  <div className="resource-dialog__table-list">
    <div className="resource-dialog__table-list-header">
      <div className="resource-dialog__table-list-header-cell resource-dialog__table-header_name">
        Name
      </div>
      <div className="resource-dialog__table-list-header-cell resource-dialog__table-header_access">
        Access Level
      </div>
      <div className="resource-dialog__table-list-header-cell resource-dialog__table-header_date">
        Date
      </div>
      <div className="resource-dialog__table-list-header-cell resource-dialog__table-header_size">
        Size
      </div>
      <div className="resource-dialog__table-list-header-cell resource-dialog__table-header_delete" />
    </div>
    {resources.map((resource, index) =>
      (<ResourcesListItem
        {...otherProps}
        key={`table-item-${resource.fullPath}`}
        index={index}
        isSelected={index === selectedIndex}
        onSelect={onSelect}
        onChangeLocation={onChangeLocation}
        resource={resource}
      >
        {props => <TableListItem {...props} />}
      </ResourcesListItem>)
    )}
  </div>
);

TableList.propTypes = {
  resources: PropTypes.arrayOf(ResourceType).isRequired,
  onChangeLocation: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired
};

export default TableList;